import type { DailySchedulePlan } from './types';

export type ApplyJobOrgResult =
  | { ok: true; plan: DailySchedulePlan }
  | { ok: false; error: 'empty_org' | 'job_not_found' };

/**
 * Patch a job's customer org on an in-memory daily plan without regenerating
 * vehicle chains or clearing manual assignments (W1 / REQ-12-503).
 */
export function applyJobOrgToPlan(
  plan: DailySchedulePlan,
  jobId: string,
  orgId: string
): ApplyJobOrgResult {
  const trimmed = orgId.trim();
  if (!trimmed) {
    return { ok: false, error: 'empty_org' };
  }

  const jobs = plan.jobs ?? [];
  const idx = jobs.findIndex((j) => j.id === jobId);
  if (idx < 0) {
    return { ok: false, error: 'job_not_found' };
  }

  const nextJobs = jobs.map((j, i) => (i === idx ? { ...j, orgId: trimmed } : j));

  return {
    ok: true,
    plan: {
      ...plan,
      jobs: nextJobs,
    },
  };
}
